import { ChangeDetectionStrategy, Component } from '@angular/core';
import { SkeletonComponent } from '../../shared/skeleton/skeleton.component';

/** Loading placeholder shaped like the search results page (filter sidebar + result cards). */
@Component({
  selector: 'inexp-search-result-skeleton',
  imports: [SkeletonComponent],
  templateUrl: './search-result-skeleton.component.html',
  styleUrl: './search-result-skeleton.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { 'aria-busy': 'true', 'aria-label': 'Loading results' },
})
export class SearchResultSkeletonComponent {
  readonly filterGroups = Array.from({ length: 3 });
  readonly filterItems = Array.from({ length: 4 });
  readonly resultCards = Array.from({ length: 5 });
  readonly cardLines = Array.from({ length: 2 });
}
